import { ref } from 'vue'

export const useAsyncWrapper = () => {
  const loading = ref(false)

  const asyncWrapper = async <T>(fn: () => Promise<T>) => {
    loading.value = true
    try {
      return await fn()
    } finally {
      loading.value = false
    }
  }

  return { loading, asyncWrapper }
}
